exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ParticipantsCounter-module__wrapper___1LehX{display:flex;align-items:baseline;justify-content:flex-end;gap:.15rem}.ParticipantsCounter-module__wrapper___1LehX svg{margin:auto .4rem;font-size:17px;opacity:.8}.ParticipantsCounter-module__wrapper___1LehX h3{font-weight:400;font-size:21px!important}.ParticipantsCounter-module__wrapper___1LehX p{font-size:15px}", ""]);

// exports
exports.locals = {
	"wrapper": "ParticipantsCounter-module__wrapper___1LehX"
};